/**
 * ContextMenuContext
 *
 * Shared context for coordinating context menu state.
 */

import { createContext } from 'react';

type ContextMenuContextType = {
  activeMenuId: string | null;
  openMenu: (menuId: string) => void;
  closeMenu: (menuId: string) => void;
};

const ContextMenuContext = createContext<ContextMenuContextType | null>(null);

export { ContextMenuContext };
export type { ContextMenuContextType };
